<template>
    <div>
        <el-form :inline="true" ref="searchModel" :model="searchModel">

            <el-form-item label="审核不通过时间">
                <el-date-picker
                        size="small"
                        v-model="approve_times"
                        type="daterange"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        format="yyyy-MM-dd"
                        value-format="timestamp"
                        align="right">
                </el-date-picker>
            </el-form-item>

            <el-form-item label="不通过原因">
                <el-select v-model="searchModel.reason" size="small">
                    <el-option  label="请选择" value=""></el-option>
                    <el-option
                            v-for="(reason, key) in getReasons()"
                            :key="key"
                            :label="reason"
                            :value="key"
                    >
                    </el-option>
                    <el-option  label="其他" value="0"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="业务组筛选：">
                <el-cascader
                        size="small"
                        :options="branches"
                        v-model="checkedBranch"
                        :props="branchesProps"
                        change-on-select
                        placeholder="请选择所属部门"
                >
                </el-cascader>
            </el-form-item>

            <el-form-item label="业务员筛选：">
                <UserSelect ref="user" v-model="searchModel.salesman_id" @change="UserHandleChange"></UserSelect>
            </el-form-item>

            <el-form-item label="订单ID：">
                <el-input size="small" placeholder="请输入订单ID" v-model.number="searchModel.order_id"></el-input>
            </el-form-item>

            <el-form-item label="客户名称：">
                <CustomerSelect ref="customer" v-model="searchModel.customer_name" @change="CustomerHandleChange"></CustomerSelect>
            </el-form-item>

            <el-form-item label="审核人：">
                <UserSelect ref="executor_id" v-model="searchModel.executor_id" @change="handleChangeExecutor"></UserSelect>
            </el-form-item>


            <el-form-item>
                <el-button icon="el-icon-search" type="primary" size="mini" @click="submitSearch">搜索</el-button>
                <el-button icon="el-icon-download" type="primary" size="mini" @click="exportLog"> 导出</el-button>
            </el-form-item>
        </el-form>


        <el-table v-loading="loading" :data="logs" border style="width: 100%" size="small" class="blue-link">
            <el-table-column align="center" label="序号" type="index" width="50"></el-table-column>
            <el-table-column align="center" label="订单ID" prop="order_id">
<!--                <template slot-scope="scope">-->
<!--                    <router-link target="_blank" :to="{path:'/order/view',query:{id: scope.row.order_id}}">-->
<!--                        <i style="color: #F56C6C;" class="el-icon-link"></i>-->
<!--                        {{ scope.row.order_id}}-->
<!--                    </router-link>-->
<!--                </template>-->
            </el-table-column>
            <el-table-column align="center" label="开通产品" prop="products"></el-table-column>
            <el-table-column align="center" label="所属客户" prop="customer_name"></el-table-column>
            <el-table-column align="center" label="审核人" prop="executor_name"></el-table-column>
            <el-table-column align="center" label="审核不通过时间" prop="created_at"></el-table-column>
            <el-table-column align="center" label="不通过原因" prop="reason_text"></el-table-column>
            <el-table-column align="center" label="业务组" prop="branch_name"></el-table-column>
            <el-table-column align="center" label="业务员" prop="salesman_name"></el-table-column>
        </el-table>

        <el-row v-if="linkPage">
            <pagination :linkPage="linkPage" :enableEvent="true" @change="watchPageChange"></pagination>
        </el-row>

    </div>
</template>

<script>

    import OrderAuditLogService from "~/services/OrderAuditLog";
    import Pagination from "~/widgets/Pagination.vue";
    import Params from "~/config/params";
    import CommonService from "~/services/common";
    import UserSelect from "~/widgets/UserSelectCorp.vue";
    import CustomerSelect from "~/widgets/CustomerSelect.vue";

    export default {
        name: "AuditList",
        components: {
            Pagination,
            UserSelect,
            CustomerSelect
        },
        props: {
            flow_type: {
                type: Number,
                required: true
            },
            reason: {
                type: Number|String,
                required: false
            }
        },
        watch: {
            approve_times: function (value, oldValue) {
                if (value && value.length > 0) {
                    if (value[0] && value[1]) {
                        this.searchModel.start_at = value[0];
                        this.searchModel.end_at = value[1];
                    }
                } else {
                    this.searchModel.start_at = '';
                    this.searchModel.end_at = '';
                }
            },
            checkedBranch: function (value, oldValue) {
                if (value.length > 0) {
                    // 得到最后一级
                    this.searchModel.branch_id = value[value.length - 1];
                }
            }
        },
        created() {
            this.searchModel.reason = this.reason;
            this.getList(this.searchModel);
            this.getBranches();
        },
        data() {
            return {
                searchModel: {
                    flow_type: this.flow_type,
                    start_at: '',
                    end_at: '',
                    reason: '',
                    branch_id: '',
                    salesman_id: '',
                    order_id: '',
                    customer_id: '',
                    customer_name: '',
                    executor_id: ''
                },

                approve_times: [],
                logs: [],
                linkPage: null,
                loading: false,

                branches: [],
                checkedBranch: [], // 选中的域名
                branchesProps: {
                    value: 'id',
                    label: 'name',
                    children: 'childs'
                },
            };
        },
        methods: {

            /**
             * 监听分页改变事件
             * @param pageParams
             */
            watchPageChange(pageParams) {
                this.searchModel['page'] = pageParams["page"];
                this.searchModel['perPage'] = pageParams["perPage"];
                this.getList(this.searchModel);
            },

            /**
             * 得到部门树状结构数据
             */
            getBranches() {
                CommonService.getAllBranches().then(res => {
                    if (res.code == 0 && res.data) {
                        let branches = res.data;
                        delete branches[0];
                        this.branches = res.data;
                    }
                });
            },

            getList(params) {
                this.loading = true;
                OrderAuditLogService.getList(params).then(res => {
                    this.loading = false;
                    if (res.code == 0) {
                        this.logs = res.data;
                        if (res._meta) {
                            this.linkPage = res._meta;
                        }
                    }
                });
            },

            getReasons() {
                return Params.getReasons(this.flow_type);
            },

            //业务员姓名远程搜索组件赋值
            UserHandleChange(value) {
                this.searchModel.salesman_id = value;
            },

            //客户名称远程搜索组件赋值
            CustomerHandleChange(object) {
                this.searchModel.customer_name = object.value;
            },

            submitSearch() {
                this.getList(this.searchModel);
            },

            exportLog() {
               OrderAuditLogService.exportAuditLog(this.searchModel);
            },

            handleChangeExecutor(value) {
                this.searchModel.executor_id = value;
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/approve/auditList.vue